export const ShoppingCart = {
    orderId: '',
    billingCode: '',
    sellerCode: '',
    branchCode: '',
    channel: '',
    orderState: '',
    country: '',
    currency: '',
    created: '',
    invoiceId: '',
    invoiceNumber: '',
    customer: null,
    shippingData: null,
    additionalPromotions: [],
    payments: [],
    paymentMethod: null,
    items: [],
    itemsToReturn: [],
    discount: 0,
    refund: 0,
    subTotal: 0,
    total: 0,
    ignoredPromotionIds: [],
    ignoredPromotions: [],
    returnMode: false,
    notAppliedPromotions: []
}